// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"0232561d","575":"0232561d","967":"4ee60963"}[chunkId] + ".chunk.css";
};